<template>
   <div class='mymenu-list batt-swap-page'>
      <div v-if="showMenuList" class="menu-list">
         <div class="menu-card" v-for="item in menuList" :key="item.id" @click="jumpMyMenuDetail(item)">
            <h2 class="menu-card-head">
               <span>{{item.name}}</span>
               <i>{{item.currencySymbol}}{{item.price | formatPrice}}/{{item.cycle}}</i>
            </h2>
            <p class="menu-card-body">
               <!-- 开通 -->
               <span>{{item.openTime}} {{$t('bstext.bs45')}}</span>
               <i :class="[item.statusClass]">{{item.statusText}}</i>
            </p>
         </div>
      </div>
      <div v-else class="no-menu-list">
         <span class="bs-icon-no-open-menu"></span>
         <!-- 您尚未开通换电套餐 -->
         <p>{{$t('bstext.bs46')}}</p>
      </div>
   </div>
</template>

<script>
import utils from '@/utils/index.js'
const statusClass={
   '1':'status-red',
   '2':'status-blue',
   '3':'status-gray',
   '4':'status-gray',
}
export default {
   data () {
      return {
         showMenuList:false,
         menuList:[],
         cycles:[],
         menus:[],
      }
   },
   mounted() {
      this.cycles=this.$t('bsstatus.cycles')
      this.menus=this.$t('bsstatus.menus')
      document.title = this.$t('bstext.bs60')
      this.getServiceOpenList()
   },
   methods: {
      getServiceOpenList(){
         this.$appApi.nativeLoading(true,'',0)         
         let req ={}
         this.$server.getServiceOpenList(req).then(res=>{
            let list =res.data
            this.showMenuList=list.length<1?false:true
            if(list.length>0){
               list.forEach(item => {
                  item.statusClass=statusClass[item.status]
                  item.statusText =utils.formatStatus(item.status,this.menus)
                  item.cycle=utils.formatStatus(item.cycle,this.cycles)
                  item.openTime =utils.formatDate(item.openTime,'yyyy.MM.dd hh:mm:ss')
               });
            }
            this.menuList=list
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      jumpMyMenuDetail(item){
         this.$router.push(`/bs/battswap/mymenudetail/${item.id}`)
      }
   }
}
</script>

<style lang='less' scoped>
.mymenu-list{
   padding: 16px 12px;
   .menu-list{    
      .menu-card{
         padding: 12px;
         background: #1B1B21;
         border-radius: 2px;
         margin-bottom: 12px;
         .menu-card-head{
            display: flex;
            justify-content: space-between;
            margin-bottom: 11px;
            span{
               // display: inline-block;
               font-size: 18px;
               font-weight: 500;
               color: #F2F2F7;
               line-height: 25px;
            }
            i{
               font-size: 14px;
               color: #FFFFFF;
               line-height: 20px;
            }
         }
         .menu-card-body{
            display: flex;
            justify-content: space-between;
            span{
               font-size: 14px;
               color: #8C92A0;
               line-height: 20px;            
            }
            i{
               text-align: center;
               padding: 0 8px;
               line-height: 21px;
               height: 21px;
               background: rgba(255, 74, 74, 0.2);
               border-radius: 2px;
               font-size: 12px;
               color: #FF4A4A;
            }
            .status-red{
               background: rgba(255, 74, 74, 0.2);
               color: #FF4A4A;
            }
            .status-blue{
               background: rgba(46, 104, 246, .2);
               color: rgba(46, 104, 246, 1);
            }
            .status-gray{
               background: rgba(242, 242, 247, 0.1);
               color: rgba(140, 146, 160, 1);
            }
         }
      }
   }
   .no-menu-list{
      margin-top: 51.2vw;
      text-align: center;
      p{
         font-size: 14px;
         color: #8C92A0;
         line-height: 14px;
         margin-top: 16px;
      }
   }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/mymenu/mymenulist.vue